import type {PageRouteConfig} from '@router';

import ProAdd from 'modules/Services/PromotionCenter/Pro/Add/ProAdd';
import {routes} from 'routes/routes';

export function createPromotionCenterProAddRoute(): PageRouteConfig {
  return {
    element: <ProAdd />,
    layout: {
      title: 'فعال‌سازی سرویس پرو',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER_PRO_LIST,
      linkWithConfirmation: true,
      modalTitle: 'خروج از فرآیند خرید سرویس پرو؟',
      modalText: 'با خروج از فرآیند, اطلاعاتی که ثبت کردید ذخیره نخواهد شد.'
    }
  };
}
